import React from "react";
import "./GenericModal.scss";

// MODULES
import { Modal } from "react-bootstrap";
const { Header, Title, Body, Footer } = Modal;

interface GenericModalProps {
    className?: string;
    show: boolean;
    onHide: () => void;
    header: string;
    body: React.ReactNode;
    footer?: React.ReactNode;
    [key: string]: any; // rest
}

const GenericModal: React.FC<GenericModalProps> = ({
    className = "",
    show,
    onHide,
    header = "",
    body,
    footer,
    ...rest
}) => {
    return (
        <Modal
            className={`GenericModal ${className}`}
            show={show}
            onHide={onHide}
            {...rest}
            //ref={ref} // NOTE TO SELF - don't even attempt this - bootstrap will not forward the ref internally
        >
            <Header closeButton>
                <Title>{header}</Title>
            </Header>
            <Body>{body}</Body>
            {footer && <Footer>{footer}</Footer>}
        </Modal>
    );
};

export default GenericModal;
